<script setup lang="ts">
defineProps<{
  color?: any
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <path
      d="M11.159,33.807c-9.006-3.503-13.466-13.64-9.966-22.647C4.696,2.153,14.837-2.31,23.841,1.196
c9.006,3.498,13.466,13.642,9.966,22.645C30.304,32.849,20.163,37.308,11.159,33.807"
    />
    <path
      fill="#FFFFFF"
      d="M26.124,26.046c0.283-0.244,0.357-0.662,0.147-0.984c-0.027-0.039-0.053-0.074-0.08-0.104V24.95
l-3.657-4.037l-0.011,0.002c-0.242-0.274-0.654-0.34-0.978-0.135c-0.027,0.017-0.059,0.043-0.081,0.066
c-0.021,0.018-0.037,0.034-0.052,0.049c-0.38,0.352-0.387,0.406-0.7,0.718c-0.452,0.45-1.011,1.171-1.59,2.005
c-1.178-0.453-2.756-1.902-4.307-4.316c-1.554-2.412-2.216-4.449-2.138-5.705c0.999-0.18,1.889-0.39,2.487-0.604
c0.413-0.158,0.468-0.147,0.945-0.345c0.016-0.01,0.038-0.019,0.058-0.026l0.004-0.007c0.032-0.01,0.069-0.023,0.1-0.043
c0.318-0.207,0.428-0.608,0.281-0.949l0,0l-2.152-5.006h-0.003c-0.021-0.045-0.037-0.078-0.06-0.118
c-0.21-0.321-0.621-0.433-0.961-0.275c-2.386,0.968-4.6,2.125-4.758,4.028c-0.168,2.037,1.248,6.921,3.669,10.678
c2.416,3.762,6.274,7.076,8.195,7.773C22.281,29.351,24.248,27.81,26.124,26.046"
    />
  </svg>
</template>
